export const defaultAlertDisplayTime = 3000;
export const longAlertDisplayTime = 10000;
export const exitAnimationTime = 300;
